export default __webpack_public_path__ + "static/media/MyTeamIcon.9d188c50.svg";